/**
 * QL-375 group 7 — under portfolio-level blocking the goal page's panel is
 * informational; this list names each portfolio's own verdict (and a decision
 * when one stands) so the advisor sees which portfolio blocks without opening
 * every tab. Decisions are taken on the portfolio page, never here.
 */

import type { MandatePortfolioVerdict } from "@repo/shared/types";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./mandate-portfolio-summary.i18n";
import { MandateVerdictBadge } from "./mandate-verdict-badge";

type Props = {
  verdicts: MandatePortfolioVerdict[];
};

export function MandatePortfolioSummary({ verdicts }: Props) {
  const t = useT(T);
  if (verdicts.length === 0) return null;
  return (
    <div className="rounded-lg bg-muted/40 p-4 space-y-1.5">
      <div className="text-sm font-medium">{t.portfolioVerdictsTitle}</div>
      {verdicts.map((v) => (
        <div key={v.portfolioId} className="flex items-center justify-between gap-3 text-sm">
          <span>
            {v.name}
            {v.decision?.decidedBy?.name && (
              <span className="text-muted-foreground">
                {" · "}
                {(v.decision.decision === "accepted" ? t.acceptedByName : t.blockedByName)(
                  v.decision.decidedBy.name,
                )}
              </span>
            )}
          </span>
          {
            <MandateVerdictBadge
              effective={v.effective}
              notEvaluableReason={v.notEvaluableReason}
              informational={!v.effective && !v.notEvaluableReason}
            />
          }
        </div>
      ))}
    </div>
  );
}
